import React, { useEffect, useState, useContext } from "react";
import "./requisitionDashboard.css";
import { useLocation ,useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Tooltip  from "@mui/material/Tooltip";
import getAllRequisitionStatus from "../../apis/getallRequisitionStatus/getAllRequisitionStatus";
import getAllRequisitionStatusAndCounts from "../../apis/requisitionDetails/getAllRequisitionStatusAndCounts";
import getAllRecruiterRequisitionStatusAndCounts from '../../apis/requisitionDetails/getAllRecruiterRequisitionStatusAndCounts';
import getAllRecruiterLeaderRequisitionStatusAndCounts from '../../apis/requisitionDetails/getAllRecruiterLeaderRequisitionStatusAndCounts';
import getAllTeamLeaderRequisitionStatusAndCounts from '../../apis/requisitionDetails/getAllTeamLeaderRequisitionStatusAndCounts';
import config from "../../Config.json";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
import RequisitionListCard from "../../components/RequisitionsList/RequisitionListCard";
import { UserTypeContext } from "../../AppRoute";

const RequisitionDashboard = (props) => {
  const location = useLocation();
  const { userType, userRecords } = useContext(UserTypeContext);
  const userRole = location?.state?.userRole ? location?.state?.userRole : userRecords?.role?.roleName;
  const userRecruitmentpartnerId = location?.state?.userRecruitmentpartnerId ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId;
  const idContextTest = location?.state?.id ? location?.state?.id : userRecords?.id;
  const userRecordData = userType === "Admin" ? location?.state?.userRecords : userRecords;

  const [statusCounts, setStatusCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [requisitionStatus, setRequisitionStatus] = useState([]);
  const [status, setStatus] = useState("");
  const [selectedFilter, setSelectedFilter] = useState({
    covered: "",
    priority: "",
    latestDate: true
  });
  const [searchText, setSearchText] = useState("");
    const history = useNavigate();

  // Filter functions
  const filterChange = (filterType, value) => {
    setSelectedFilter(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const filterChangeToCover = (str) => {
    let subStatusArr = requisitionStatus?.filter(
      (item, i) => item.statusCode === config?.requisitionStatusCodes?.OPEN
    )[0]?.subList;
    let code = str
      ? subStatusArr.filter((item, i) => item.subName === str)[0]?._id
      : "";
    filterChange("covered", code);
  };

  const searchTextChangeHandler = (event) => {
    setSearchText(event.target.value);
  };

  // Status counts and requisition status fetching logic below

  useEffect(() => {
    let isMounted = true;

    const getReqStatusAndCounts = async () => {
      try {
        let payload = {
          isDashBoardCount: false,
          isOrgAdmin: userType === "Organization Admin" || (userType === "Admin" && userRole === "Organization Admin") ? true : false,
          isMISOperator: userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator") ? true : false,
          recruitmentpartnerId:userRecruitmentpartnerId
        };
        setLoading(true);
        const response =
          userType === "Recruiter" || (userType === "Admin" && userRole === "Recruiter")
            ? await getAllRecruiterRequisitionStatusAndCounts(idContextTest, payload)
            : userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator")
              ? await getAllRequisitionStatusAndCounts(userRecruitmentpartnerId, payload)
              : userType === "Organization Admin" || (userType === "Admin" && userRole === "Organization Admin")
                ? await getAllRequisitionStatusAndCounts(userRecruitmentpartnerId, payload)
                : userType === "Recruitment Leader" || (userType === "Admin" && userRole === "Recruitment Leader")
                  ? await getAllRecruiterLeaderRequisitionStatusAndCounts(idContextTest, payload)
                  : userType === "Team Leader" || (userType === "Admin" && userRole === "Team Leader")
                    ? await getAllTeamLeaderRequisitionStatusAndCounts(idContextTest, payload)
                    : null;

        if (isMounted) {
          setStatusCounts(response?.data?.data || []);
          setLoading(false);
        }
      } catch (err) {
        console.log(err, "error");
        if (isMounted) setLoading(false);
      }
    };

    getReqStatusAndCounts();

    return () => {
      isMounted = false;
    };
  }, [idContextTest, userRecruitmentpartnerId, userRole, userType]);

  // Get requisition status options
  useEffect(() => {
    let isMounted = true;

    const getRequisitionStatus = async () => {
      try {
        const response = await getAllRequisitionStatus();
        if (isMounted) {
          setRequisitionStatus(response?.data?.data || []);
        }
      } catch (err) {
        console.log(err, "error");
      }
    };

    if (userRecruitmentpartnerId) {
      getRequisitionStatus();
    }

    return () => {
      isMounted = false;
    };
  }, [userRecruitmentpartnerId,userType]);

  const stats = [
    { label: "Total Requisitions", value: statusCounts?.totalCount || 0, status: "ALL" },
    { label: "High Priority Requirements", value: statusCounts?.highPriorityRequisitonCount || 0, status: "ALL", priority: "High" },
    { label: "Open", value: statusCounts?.statusBasedCount?.OPEN || 0, status: "RS01" },
    { label: "Closed", value: statusCounts?.statusBasedCount?.CLOSED || 0, status: "RS02" },
    { label: "On Hold", value: statusCounts?.statusBasedCount?.ONHOLD || 0, status: "RS03" },
    { label: "Filled", value: statusCounts?.statusBasedCount?.FILLED || 0, status: "RS04" },
    { label: "Cancelled", value: statusCounts?.statusBasedCount?.CANCELLED || 0, status: "RS05" },
  ];

  const handleStatClick = (stat) => {
    // Find the matching status from reqStatus array
    let matchedStatus = "";
    
    if (stat.status !== "ALL") {
      const foundStatus = reqStatus.find(item => item.statusCode === stat.status);
      matchedStatus = foundStatus ? foundStatus.statusCode : stat.status;
    } else {
      matchedStatus = "ALL";
    }

    setStatus(matchedStatus);
    if (stat.priority) {
      setSelectedFilter(prev => ({ ...prev, priority: stat.priority }));
    } else {
      setSelectedFilter(prev => ({ ...prev, priority: "" }));
    }
  };

  const [reqStatus,setReqStatus] = useState([])

   useEffect(() => {
    let isMounted = true;

    const getReqStatus = async () => {
      try {
        const res = await getAllRequisitionStatus();
        if (isMounted) {
          setReqStatus(res.data.data);
        }
      } catch (error) {
        console.log("Error", error);
      }
    };

    getReqStatus();

    return () => {
      isMounted = false;
    };
  }, []);

  const goToDashboard = () => {
    history("/dashboard",
      {
        state: {
          userType: userType,
          recruitmentPartnerId: userRecruitmentpartnerId,
          id: idContextTest,
          userRecords: userRecordData,
          roleName: userRole,
        },
      });
  };


  return (
    <>
    {
      userType !== "Candidate" ? (<div className="dashboard-container">
      <div className="main-content">
        <section className="requisitions-section">
          <div className="section-header">
            <div className="title-and-back">
              <div className="goBackButton"  onClick={(e) => goToDashboard(e)}>
                <Tooltip title="Go Back to Dashboard" placement="bottom">
                  <ArrowBackIcon sx={{ fontSize: 20 }} />
                </Tooltip>
              </div>
              <h1 className="section-title">
                {(status === "ALL" && selectedFilter?.priority === "High") ? "High Priority" :
                  !status
                    ? "OPEN"
                    : status === "ALL"
                      ? "All"
                      : reqStatus
                        ?.find(item => item.statusCode === status)
                        ?.name?.toUpperCase() || status
                } Requisitions
              </h1>
            </div>
            <div className="search-container">
              <OutlinedInput
                className="search-input"
                placeholder="Search requisitions..."
                value={searchText}
                onChange={searchTextChangeHandler}
                endAdornment={
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                }
              />
            </div>
          </div>
          {userType !== "MIS Operator" && (
            <div className="req-filter-section">
              <button
                className={
                  selectedFilter.covered
                    ? "filter-btn-selected"
                    : "filter-btn"
                }
                onClick={(e) =>
                  selectedFilter.covered
                    ? filterChangeToCover("")
                    : filterChangeToCover("COVERED")
                }
              >
                <span>Covered</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.986 5.424a54 54 0 0 0-11.972 0a.343.343 0 0 0-.228.556l3.517 4.348a8.75 8.75 0 0 1 1.947 5.503v2.889l1.5 1.1v-3.99a8.75 8.75 0 0 1 1.947-5.502l3.517-4.348a.343.343 0 0 0-.228-.556M5.848 3.933a55.4 55.4 0 0 1 12.305 0c1.446.162 2.143 1.858 1.228 2.99l-3.517 4.348a7.25 7.25 0 0 0-1.614 4.56V21.3a.75.75 0 0 1-1.194.605l-3-2.2a.75.75 0 0 1-.306-.605v-3.27c0-1.66-.57-3.269-1.613-4.56L4.62 6.924c-.916-1.132-.22-2.828 1.228-2.99" clip-rule="evenodd" strokeWidth="0.5" stroke="currentColor"/></svg>
              </button>
              
              <button
                className={
                  selectedFilter?.priority
                    ? "filter-btn-selected"
                    : "filter-btn"
                }
                onClick={(e) =>
                  selectedFilter?.priority
                    ? filterChange("priority", "")
                    : filterChange("priority", "High")
                }
              >
                <span>High Priority</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.986 5.424a54 54 0 0 0-11.972 0a.343.343 0 0 0-.228.556l3.517 4.348a8.75 8.75 0 0 1 1.947 5.503v2.889l1.5 1.1v-3.99a8.75 8.75 0 0 1 1.947-5.502l3.517-4.348a.343.343 0 0 0-.228-.556M5.848 3.933a55.4 55.4 0 0 1 12.305 0c1.446.162 2.143 1.858 1.228 2.99l-3.517 4.348a7.25 7.25 0 0 0-1.614 4.56V21.3a.75.75 0 0 1-1.194.605l-3-2.2a.75.75 0 0 1-.306-.605v-3.27c0-1.66-.57-3.269-1.613-4.56L4.62 6.924c-.916-1.132-.22-2.828 1.228-2.99" clip-rule="evenodd" strokeWidth="0.5" stroke="currentColor"/></svg>
              </button>
              
              <button
                className={
                  selectedFilter.latestDate
                    ? "filter-btn-selected"
                    : "filter-btn"
                }
                onClick={(e) =>
                  selectedFilter.latestDate
                    ? filterChange("latestDate", false)
                    : filterChange("latestDate", true)
                }
              >
                <span>Latest Date</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.986 5.424a54 54 0 0 0-11.972 0a.343.343 0 0 0-.228.556l3.517 4.348a8.75 8.75 0 0 1 1.947 5.503v2.889l1.5 1.1v-3.99a8.75 8.75 0 0 1 1.947-5.502l3.517-4.348a.343.343 0 0 0-.228-.556M5.848 3.933a55.4 55.4 0 0 1 12.305 0c1.446.162 2.143 1.858 1.228 2.99l-3.517 4.348a7.25 7.25 0 0 0-1.614 4.56V21.3a.75.75 0 0 1-1.194.605l-3-2.2a.75.75 0 0 1-.306-.605v-3.27c0-1.66-.57-3.269-1.613-4.56L4.62 6.924c-.916-1.132-.22-2.828 1.228-2.99" clip-rule="evenodd" strokeWidth="0.5" stroke="currentColor"/></svg>
              </button>
            </div>
          )}

         

          <div className="requisitions-list">
            {/* Scrollable Requisition List Container */}
            <div className="scrollable-requisition-container">
              <RequisitionListCard
                hideHeader={true}
                externalSearchText={searchText}
                userType={userType}
                userRole={userRole}
                idContextTest={idContextTest}
                userRecruitmentpartnerId={userRecruitmentpartnerId}
                requisitionStatus={requisitionStatus}
                status={status}
                selectedFilter={selectedFilter}
                userRecords={userRecords}
                filterChange={filterChange}
              />
            </div>
          </div>
        </section>

        <aside className="sidebar">
          <div className="sidebar-header">
            <h2 className="sidebar-title">Requisition Dashboard</h2>
          </div>
          {loading ? (
            <div className="loading">Loading...</div>
          ) : (
            <div className="stats-list">
              {stats.map((stat, index) => (
                <div 
                  key={index} 
                  className="stat-item clickable-stat" 
                  onClick={() => handleStatClick(stat)}
                >
                  <span className="stat-label">{stat.label}</span>
                  <span className="stat-value">{stat.value}</span>
                </div>
              ))}
            </div>
          )}
        </aside>
      </div>
    </div>) : (
      <UnauthorizedAccess />
    )
    }
    </>
    
  )
}

export default RequisitionDashboard




